"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socketXLSXResponse = exports.socketSuccessForRecord = exports.socketSuccess = exports.socketResponseForRecord = exports.socketResponse = exports.socketResetForRecord = exports.socketReset = exports.socketPDFResponse = exports.socketNotificationRemove = exports.socketNotificationRead = exports.socketNotificationMuteUnMute = exports.socketMinimizeProcess = exports.socketLoadingForRecord = exports.socketLoading = exports.socketErrorForRecord = exports.socketError = void 0;
var _socket = require("./socket.constant");
// @flow

// common success
var socketSuccess = function socketSuccess(actionType, data) {
  return {
    type: _socket.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};
exports.socketSuccess = socketSuccess;
var socketSuccessForRecord = function socketSuccessForRecord(actionType, data) {
  return {
    type: _socket.actionTypes.SOCKET_SUCCESS_RECORD,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.socketSuccessForRecord = socketSuccessForRecord;
var socketError = function socketError(actionType, error) {
  return {
    type: _socket.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};
exports.socketError = socketError;
var socketErrorForRecord = function socketErrorForRecord(actionType, error) {
  return {
    type: _socket.actionTypes.SOCKET_ERROR_RECORD,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * success
 * @param payload
 * @returns api response
 * @description this function used to handle success response.
 */
exports.socketErrorForRecord = socketErrorForRecord;
var socketResponse = function socketResponse(data) {
  return {
    type: _socket.actionTypes.SOCKET_RESPONSE,
    payload: data
  };
};
exports.socketResponse = socketResponse;
var socketResponseForRecord = function socketResponseForRecord(data) {
  return {
    type: _socket.actionTypes.SOCKET_RESPONSE_RECORD,
    payload: data
  };
};

/**
 * success
 * @param payload
 * @returns api response
 * @description this function used to handle success response.
 */
exports.socketResponseForRecord = socketResponseForRecord;
var socketPDFResponse = function socketPDFResponse(data) {
  return {
    type: _socket.actionTypes.SOCKET_PDF,
    payload: data
  };
};

/**
 * loading
 * @param payload
 * @returns api response
 * @description this function used to handle loading response.
 */
exports.socketPDFResponse = socketPDFResponse;
var socketLoading = function socketLoading(data) {
  return {
    type: _socket.actionTypes.SOCKET_LOADING,
    payload: data
  };
};
exports.socketLoading = socketLoading;
var socketLoadingForRecord = function socketLoadingForRecord(data) {
  return {
    type: _socket.actionTypes.SOCKET_LOADING_RECORD,
    payload: data
  };
};

/**
 * delete notification
 * @param payload
 * @returns api response
 * @description this function used to delete notification.
 */
exports.socketLoadingForRecord = socketLoadingForRecord;
var socketNotificationRemove = function socketNotificationRemove(data) {
  return {
    type: _socket.actionTypes.NOTIFICATION_DELETE,
    payload: data
  };
};

/**
 * mute/unmute notification
 * @param payload
 * @returns api response
 * @description this function used to mute/unmute notification.
 */
exports.socketNotificationRemove = socketNotificationRemove;
var socketNotificationMuteUnMute = function socketNotificationMuteUnMute(data) {
  return {
    type: _socket.actionTypes.MUTE_UNMUTE,
    payload: data
  };
};

/**
 * read notification
 * @param payload
 * @returns api response
 * @description this function used to read notification.
 */
exports.socketNotificationMuteUnMute = socketNotificationMuteUnMute;
var socketNotificationRead = function socketNotificationRead(data) {
  return {
    type: _socket.actionTypes.READ,
    payload: data
  };
};

/**
 * minimize notification
 * @param payload
 * @returns api response
 * @description this function used to minimize notification.
 */
exports.socketNotificationRead = socketNotificationRead;
var socketMinimizeProcess = function socketMinimizeProcess(data) {
  return {
    type: _socket.actionTypes.MINIMIZE,
    payload: data
  };
};

/**
 * minimize notification
 * @param payload
 * @returns api response
 * @description this function used to minimize notification.
 */
exports.socketMinimizeProcess = socketMinimizeProcess;
var socketXLSXResponse = function socketXLSXResponse(data) {
  return {
    type: _socket.actionTypes.XLSX,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to rest socket response.
 */
exports.socketXLSXResponse = socketXLSXResponse;
var socketReset = function socketReset() {
  return {
    type: _socket.actionTypes.RESET
  };
};
exports.socketReset = socketReset;
var socketResetForRecord = function socketResetForRecord() {
  return {
    type: _socket.actionTypes.SOCKET_RESET_RECORD
  };
};
exports.socketResetForRecord = socketResetForRecord;